export default "__VITE_ASSET__CcHKjqNu__"